import { useWrapAsync } from "@paroicms/front-app-log";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { fetchReferences } from "../../../../api/application/reference";
import { getGeneratedReferences } from "../../../../api/shared/get-references";
import { apiRequestWrapper } from "../../../../api/shared/http-client";
import { useAppStore } from "../../../../store/app.store";
import Navbar from "../../parts/Navbar/Navbar";
import Spinner from "../../utils/Spinner/Spinner";
import DefineDefaultReference from "./DefineDefaultReference/DefineDefaultReference";
import DefineKpi from "./DefineKpi/DefineKpi";

export default function SettingsScreen() {
  const { generatedReferences, setGeneratedReferences } = useAppStore();
  const wrapAsync = useWrapAsync();
  const { pathname } = useLocation();

  useEffect(
    wrapAsync(async () => {
      if (generatedReferences === undefined) {
        await apiRequestWrapper(async () => {
          const result = await fetchReferences({ limit: 200, page: 1 });
          setGeneratedReferences(getGeneratedReferences(result.data));
        });
      }
    }),
    [generatedReferences, pathname],
  );

  if (!generatedReferences) return <Spinner />;
  return (
    <div className="SettingsScreen">
      <Navbar pageTitle="Configuration" />
      <div className="Container">
        <div className="Container-content">
          <DefineDefaultReference generatedReferences={generatedReferences} />
          <DefineKpi className="mt-4" generatedReferences={generatedReferences} />
        </div>
      </div>
    </div>
  );
}
